<template>
  <!-- 历史咨询 -->
  <div class="eprights-cont">
    <div class="left-tabs">
      <a @click="gotoOnline">在线咨询</a>
      <a class="active" @click="gotoHistory">历史咨询</a>
    </div>
    <div class="right-laws">
      <div class="g-main">
        <h3 class="titleh3">历史咨询</h3>
        <div class="table-box">
          <a-table
            :columns="columns"
            :data-source="tableList"
            bordered
            :pagination="pagination"
            :customRow="gotoConsultDetail"
            :rowKey="(tableList) => tableList.pkid"
            @change="handleTableChange"
          ></a-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHistoryConsultList } from '@/api/consult';

const columns = [
  {
    title: '办件编号',
    dataIndex: 'serial_number',
    key: 'serial_number',
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '处理情况',
    dataIndex: 'trans_status_name',
    key: 'trans_status_name',
  },
  {
    title: '提交时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
  {
    title: '提交对象',
    dataIndex: 'accept_unit',
    key: 'accept_unit',
  },
];
const tableList = [];
export default {
  name: 'HistoryCult',
  data() {
    return {
      tableList,
      columns,
      pagination: {
        total: 0,
        pageSize: 1,
        current: 1,
      },
      queryParam: {
        page: 1,
        rows: 10,
      },
    };
  },
  mounted() {
    this.getHistoryCultList();
  },
  methods: {
    async getHistoryCultList() {
      let that = this;
      let category = this.$store.state.category;
      getHistoryConsultList(this.queryParam).then((res) => {
        let r = res.items;
        this.pagination.total = res.totalcount;
        this.pagination.pageSize = res.pagesize;
        r.forEach(function (item, index) {
          item.trans_status_name = category.TransStatus[item.trans_status];
        });
        this.tableList = r;
        return res;
      });
    },
    gotoConsultDetail(record, index) {
      return {
        on: {
          click: () => {
            let routeUrl = this.$router.resolve({
              name: 'consultDetail',
              query: { id: record.pkid },
            });
            window.open(routeUrl.href, '_blank');
          },
        },
      };
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.queryParam.page = pagination.current;
      this.queryParam.rows = pagination.pageSize;
      this.getHistoryCultList();
    },
    gotoOnline() {
      this.$router.push({ name: 'OnlineCult' });
    },
    gotoHistory: function () {
      this.$router.push({ name: 'HistoryCult' });
    },
  },
};
</script>
<style scoped>
.eprights-cont {
  display: flex;
}

.left-tabs {
  width: 260px;
  text-align: center;
  padding-top: 20px;
}

.left-tabs a {
  display: inline-block;
  width: 220px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #666;
  background: #fafbfc;
  border: 1px solid #d9dfe8;
  box-sizing: border-box;
}

.left-tabs a + a {
  margin-top: 10px;
}

.left-tabs a.active {
  color: #0079df;
  background: #f3f9ff;
  border: 1px solid #78c1ff;
}

.right-laws {
  flex: 1;
  padding-top: 10px;
  padding-right: 20px;
}
</style>
